import { createContext, useContext } from 'react'

import { useActiveForm } from '@/components/form/ActiveSwitch'

const OfferActiveContext = createContext({})

export const useOfferActive = () => useContext(OfferActiveContext)

export const OfferActiveProvider = ({ item, children }) => {
  const { active, setActive } = useActiveForm(item)
  return <OfferActiveContext.Provider value={{ active, setActive }}>
    {children}
  </OfferActiveContext.Provider>
}
